import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { CellDropdownSWReactTableOnRowHover } from "./components/CellSiteDropdown";

export const PagesTableWrapper = styled.div<{ addMarginTop: boolean }>`
    margin-top: ${({ addMarginTop }) => (addMarginTop ? "50px" : "0")};

    ${CellDropdownSWReactTableOnRowHover}
`;

export const TopStyled = styled.div`
    display: flex;
    align-items: center;
    padding: 12px;
    gap: 16px;
`;

export const Right = styled.div`
    flex-grow: 0;
    display: flex;
    align-items: center;
    margin-left: 10px;
`;
export const ChipdownItem = styled.div`
    [data-automation-icon-name="arrow"] svg {
        width: 10px;
        height: 5px;
    }
`;

export const StyledCheckboxContainer = styled.div`
    align-items: center;
    display: flex;
`;

export const StyledInfoIcon = styled.div`
    cursor: pointer;
    margin-left: 8px;
`;
export const PopularPagesContainer = styled.div``;

export const StyledTableTitle = styled(Text)`
    height: 63px;
    background-color: ${colorsPalettes.carbon[0]};
    padding: 20px 24px;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    display: block;
`;
